#!/usr/bin/env node

import runCLI from './index.js';

process.removeAllListeners('warning');

runCLI();
